import React, { useEffect, useState } from "react";

/** Component */
import { Tabs, Tab, ButtonGroup, Button, Tooltip } from "@mui/material";
// import RptCusDebt from "../report/rptCusDebt";
import RptCusExpDebt from "../report/rptCusExpDebt";
import SubSaleDebt from "./subSaleDebt.component";

/** Icon */
import MenuOpenIcon from "@mui/icons-material/MenuOpen";

/** Api & Function */
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Hook */
import { useDispatch } from "react-redux";

export default function SaleDebt() {
  /** Construction */
  const dispatch = useDispatch();

  /** Components */
  const tabInfor = [
    { id: 0, title: "Công nợ quá hạn (VND)" },
    { id: 1, title: "Công nợ quá hạn (USD)" },
    { id: 2, title: "Thông tin tiền thanh toán" },
  ];

  /** Init State */
  const [tab, setTab] = useState(0);
  const [open, setOpen] = useState(true);

  /** Set title for component */
  useEffect(() => {
    dispatch(setHeaderTitle("BÁO CÁO CÔNG NỢ QUÁ HẠN - KINH DOANH"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div style={{ justifyContent: "space-between", display: "flex", backgroundColor: "#b3deff", marginBottom: 20, marginTop: 10, height: 40 }}>
        <Tabs style={{ height: 40 }} value={tab}>
          {tabInfor.map((item, index) => (
            <Tab key={index} sx={{ fontWeight: "regular" }} label={item.title} wrapped onClick={() => setTab(index)} />
          ))}
        </Tabs>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button onClick={() => setOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <MenuOpenIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      {tab === 2 ? <SubSaleDebt open={open} tab={tab} /> : <RptCusExpDebt open={open} tab={tab} />}
    </div>
  );
}
